<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddDealerParts</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
      </div>
      <form [formGroup]="addDealerPartsForm" (ngSubmit)="addDealerParts()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="form-row">
                <!-- Dealer Selection drop down  -->
                <div class="col-6 af-form-group">
                  <label for="dealer" translate>lblSelectDealer
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <ng-select formControlName="dealerName" placeholder="{{ 'lblSelectDealer' | translate }}"
                      [(ngModel)]="SelectedDealer" (change)="getDealerPartsList()">
                      <ng-option *ngFor="let category of dealerList" [value]="category.value"
                        >
                        {{category.text}}</ng-option>
                    </ng-select>
                    <div *ngIf="cpf.dealerName.invalid && (cpf.dealerName.dirty || cpf.dealerName.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.dealerName.errors.required"><span translate>lblDealerRequired</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- PartNumber drop down -->
                <div class="col-6 af-form-group">
                  <label for="partNumber" translate>lblPartNumber
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <ng-select formControlName="partNumber" placeholder="{{ 'lblSelectPartNumber' | translate }}"
                      [(ngModel)]="SelectedParts">
                      <ng-option *ngFor="let category of partsList" [value]="category.id">
                        {{category.partNumber}}</ng-option>
                    </ng-select>
                    <div *ngIf="cpf.partNumber.invalid && (cpf.partNumber.dirty || cpf.partNumber.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.partNumber.errors.required"><span translate>lblPartNumbeRrequired</span>
                      </div>
                    </div>
                    <div *ngIf="noPartsAvailable" class="help-block mt-1 text-danger"> <em
                        class="ft-alert-circle align-middle" aria-hidden="true"></em>
                      <span translate>lblNoPartsAvailable</span>
                    </div>
                  </div>
                </div>

                <!-- Convert to Part number -->
                <div class="col-6 af-form-group" [hidden]='true'>
                  <label for="convertToPartNumber" translate>lblConvertToPartNumber
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <input formControlName="convertToPartNumber" class="form-control"
                      placeholder="{{ 'lblEnterconvertToPartNumber' | translate }}"
                      [ngClass]="{'is-invalid': cpf.convertToPartNumber.invalid && cpf.convertToPartNumber.touched}"
                      maxlength="10">
                    <div
                      *ngIf="cpf.convertToPartNumber.invalid && (cpf.convertToPartNumber.dirty || cpf.convertToPartNumber.touched)"
                      class="help-block mt-1 text-danger"> <em class="ft-alert-circle align-middle"
                        aria-hidden="true"></em>
                      <span translate>lblConvertToPartNumberRequired</span>
                    </div>
                  </div>
                </div>

                <!-- Quantity -->
                <div class="col-6 af-form-group">
                  <label for="convertToPartNumber" translate>lblQuantity
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <input formControlName="quantity" class="form-control mb-2" pattern="^(0|[1-9][0-9]*)$"
                      placeholder="{{ 'lblEnterQuantity' | translate }}"
                      [ngClass]="{'is-invalid': cpf.quantity.invalid && cpf.quantity.touched}" maxlength="5">
                    <div *ngIf="cpf.quantity.invalid && (cpf.quantity.dirty || cpf.quantity.touched)"
                      class="help-block mt-1 text-danger"> <em class="ft-alert-circle align-middle"
                        aria-hidden="true"></em>
                      <div *ngIf="cpf.quantity.errors.required"><span translate>lblQuantityRequired</span></div>
                      <div *ngIf="cpf.quantity.errors.pattern"><span translate>lblOnlyNumbersAreAllowed</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- UnitPrice -->
                <div class="col-6 af-form-group">
                  <label for="unitPrice" translate>lblUnitPrice
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <input type="text" formControlName="unitPrice" class="form-control" placeholder="Enter unit price"
                      pattern="^[\d,.\s]+$" required maxlength="10" [ngModel]="unitPrice | number:'1.2-2'"
                      (blur)="onBlur($event)"
                      [ngClass]="{'is-invalid': cpf.unitPrice.invalid && cpf.unitPrice.touched}">
                    <div *ngIf="cpf.unitPrice.invalid && (cpf.unitPrice.dirty || cpf.unitPrice.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.unitPrice.errors.required"><span translate>lblUnitPriceRequired</span></div>
                      <div *ngIf="cpf.unitPrice.errors.pattern"><span translate>lblProperValue</span>
                      </div>
                      <div *ngIf="cpf.unitPrice.errors.unitPriceFlag"><span translate>lblUnitPriceMessage</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label>&nbsp;</label>
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
        <div class="row">
          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
            <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align" [disabled]="!addDealerPartsForm.valid"
              translate><em class="fa fa-plus font16 align-top mr-2"></em>lblAdd</button>
            <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
          </div>
        </div>
      </div>
      </form>
    </div>
  </div>
</div>